/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { debounce } from 'debounce'
import { DashboardHeader } from '@modules/admin/Admin.Header'
import AsyncProfessionalField from '@modules/formFields/AsyncProfessionalField'
import { useTranslation } from 'react-i18next'
import Consultations from '@services/Consultations'
import history from '@services/History'
import styled, { css } from 'styled-components'
import Processing from '../../core/components/Loading'
import { fetchRelationList } from './actions'
import { defaultFilters } from './constants'
import { RelationsModal } from './Relations.Modal'
import RelationsTable from './Relations.Table'
import { FilterBarRelations, Banner } from './templates'
const RELATED = 'related'

const RelationsIndex = () => {
  const { t } = useTranslation()
  const [page, setPage] = useState(0)
  const [showModal, setShowModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [professional, setProfessional] = useState(history.location.state || null)
  const [data, setData] = useState([])
  const [error, setError] = useState(null)
  const [selected, setSelected] = useState([])
  const [filters, setFilters] = useState(defaultFilters)
  const debounceFetch = debounce(() => fetchList(filters, RELATED), 350, false)

  console.log('showModal', showModal)

  const revokeRelation = async () => {
    setLoading(true)
    try {
      await Consultations.relations.revokeRelation(professional.hash, { customer_hashes: selected })
      setSelected([])
      fetchRelationList({
        professionalHash: professional.hash,
        kind: RELATED,
        setData,
        setLoading,
        extraFilters: filters,
        page,
        setError,
      })
    } catch (e) {
      console.log(e)
    }
  }

  const toggleSelected = (hash) => {
    if (selected.includes(hash)) {
      setSelected(selected.filter((el) => el !== hash))
    } else {
      setSelected([...selected, hash])
    }
  }

  const toggleAll = (e) => {
    let hashesRelated = data.map((el) => el.hash)
    if (e.target.checked) {
      setSelected([...selected, ...hashesRelated])
    } else {
      setSelected(selected.filter((el) => !hashesRelated.includes(el)))
    }
  }
  const fetchList = (filters, kind) => {
    if (professional?.hash) {
      fetchRelationList({
        professionalHash: professional.hash,
        kind,
        setData,
        setLoading,
        extraFilters: filters,
        page,
        setError,
      })
    }
  }

  const addToRelationList = () => {
    setShowModal(false)
    fetchList(filters, RELATED)
  }

  // when clicking professional dropdown
  useEffect(() => {
    fetchList(filters, RELATED)
  }, [professional])

  // when typping on search
  useEffect(() => {
    if (professional) debounceFetch()
  }, [filters.search])

  return (
    <RelationWrapper>
      <DashboardHeader title={t('relateUsers')} total={10}>
        {professional && (
          <>
            <Button onClick={() => setShowModal(true)}>{t('Crear relación')}</Button>
            <Button danger disabled={!selected.length} onClick={revokeRelation}>
              {t('Borrar Seleccionados')}
            </Button>
          </>
        )}
      </DashboardHeader>
      <AsyncProfessionalField
        valueKey={'hash'}
        labelKey={'name'}
        input={{ value: professional, onChange: (prof) => setProfessional(prof) }}
      />
      {professional && (
        <FilterBarRelations
          t={t}
          setPage={setPage}
          doFetchList={() => fetchList(filters, RELATED)}
          filters={filters}
          setFilters={setFilters}
        />
      )}
      {!!data.length && !loading && <Label>{t('userRelatedProfessional')}</Label>}
      {!!data.length && !loading && (
        <RelationsTable
          customers={data}
          selectedCustomers={selected}
          select={toggleSelected}
          selectAll={toggleAll}
          scrollable={false}
        />
      )}
      {professional && !data.length && !loading && !error && <Banner>There is no data</Banner>}
      {professional && !loading && error && <Banner danger>{error}</Banner>}
      <Processing isFetching={loading} />
      {showModal && (
        <RelationsModal
          professionalHash={professional?.hash}
          addToRelationList={addToRelationList}
          closeModal={() => setShowModal(false)}
          doFetchList={fetchList}
          setError={setError}
        />
      )}
    </RelationWrapper>
  )
}

const Label = styled.div`
  padding: 10px;
  text-align: center;
  font-size: 15px;
  background: #e4f8ff;
`
const RelationWrapper = styled.div`
  .sm-body {
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .md-select-basic {
    display: block;
    margin: 18px 18px 0px 18px;
  }
`
const Button = styled.button.attrs({
  className: 'btn btn-primary',
})`
  margin: 3px;
  ${(props) =>
    props.danger &&
    css`
      background: #d9534f;
    `}
`

export default RelationsIndex
